/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Baixe na App Store",
      "Conheça as pessoas pessoalmente",
      "Crie sua própria comunidade nas Hives.",
      "Encontre quem é certo para você",
      "Existe uma Hive para qualquer interesse!",
      "Um lugar seguro onde você pode ser você mesmo",
      "Escolha entre Hive Privada ou Visível.",
      "Começar",
      "Existe uma Hive para qualquer interesse",
      "Conheça um novo grupo de pessoas nas Hives no Bumble BFF",
      "Queremos te convidar para as Hives",
      "Conheça novos grupos de pessoas locais com o novo recurso do Bumble BFF, as Hives. Crie seu perfil BFF no aplicativo Bumble hoje.",
      "Baixe na Google Play",
      "Gerenciar Cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dias"
            ],
            "singular": [
                  "dia"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mês"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "anos"
            ],
            "singular": [
                  "ano"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
